import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import sealImage from "../../../assets/images/intro-message-resized.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import classes from "./Seal.module.css";

const Seal = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const sealRef = useRef(null);
  const sealMsgRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: sealRef.current,
        start: "top 30%",
      },
    });
    timeline.to(sealMsgRef.current, { opacity: 1, duration: 1, ease:'power4.out' });
  });

  return (
    <div ref={sealRef} className={classes.Seal}>
      <img src={sealImage} alt="Dickinson Seal" />
      <div ref={sealMsgRef} className={classes.Container}>
        <Container>
          <div className={classes.Message}>
            <p>
              <span className="crimson-text">Dickinson</span> has been educating
              and inspiring global leaders since 1783, and we see and do things
              differently.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Seal;
